import { ProgramEngagementsAPI } from '@cibo/core'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { TaskDataModel } from '../features/ProgramEngagementPlayer/models/TaskDataModel'
import { PROGRAMS_QUERY_KEY } from './queryKey'

type UseTaskDataProps = {
  taskId?: string
  engagementId?: string
}

export const useEngagementTaskData = (
  { engagementId, taskId }: UseTaskDataProps,
  options?: Partial<UseQueryOptions<TaskDataModel, Error>>
) =>
  useQuery<TaskDataModel, Error>({
    queryKey: [PROGRAMS_QUERY_KEY.TASK_DATA, { engagementId, taskId }],
    queryFn: async (): Promise<TaskDataModel> =>
      ProgramEngagementsAPI.getTaskData(
        // @ts-ignore these will be defined because of the enabled condition
        { engagementId, taskId }
      ).then(response => new TaskDataModel(response)),
    enabled: !!engagementId && !!taskId,
    staleTime: 1000,
    ...options,
  })
